module.exports = __webpack_public_path__ + "media/recipes/120-143c0037.png";